import { useStyles } from './CardCarouselStyle'
import Chip from '@material-ui/core/Chip'

export default function CardCarousel({ professor }) {
  const classes = useStyles()

  function onClickDetails() {
    window.location.href = `/professeurs/details/${professor.id}`
  }

  return (
    <div className={classes.cardContainer} onClick={onClickDetails}>
      {professor?.image ? (
        <img className={classes.img} src={professor?.image ?? ''} alt={professor?.name + ' ' + professor?.surname} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
      ) : (
        <img className={classes.img} src={'/no-profil-image.png'} alt={professor?.name + ' ' + professor?.surname} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />)
      }
      <div className={classes.cardContainerText}>
        <h2 className={classes.title}>{professor?.name} {professor?.surname}</h2>
        <div className={classes.activities}>
          {professor.activites.map((activity, index) => {
            if (index < 1) {
              return <Chip key={index} color="primary" label={activity.name} style={{cursor:'pointer'}} />
            } else if (index === 2) {
              return <Chip key={index} color="primary" style={{cursor:'pointer'}} label={'+' + (professor.activites.length - 2) + ' autres cours...'} />
            }
          })}
        </div>
      </div>
    </div>
  )
}
